var map = {
	"./de/general.js": "28b8",
	"./de/keys.js": "3395",
	"./de/menu.js": "52b4",
	"./de/messages.js": "a15d",
	"./de/titles.js": "3a5d",
	"./en/general.js": "513f",
	"./en/keys.js": "796e",
	"./en/menu.js": "942d",
	"./en/messages.js": "2483",
	"./en/titles.js": "120e",
	"./sk/general.js": "d69e",
	"./sk/keys.js": "6ebf",
	"./sk/menu.js": "1ad9",
	"./sk/messages.js": "b1d9",
	"./sk/titles.js": "8322"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba25";